export default __webpack_public_path__ + "static/media/kyc-pallete.fa150965.gif";